<template>
  <v-row class="justify-center py-12">
    <v-card
      :width="$vuetify.display.mobile ? `100%` : `50%`"
      :max-width="$vuetify.display.mobile ? `100%` : `50%`"
    >
      <v-window v-model="tab">
        <v-window-item value="one">
          <v-card-title class="mt-4">Új jelszó kérése</v-card-title>
          <v-card-actions style="padding: 1rem">
            <v-row class="justify-space-between align-center">
              <v-col cols="12">
                <v-text-field
                  type="text"
                  label="Email"
                  placeholder="Email cím"
                  variant="underlined"
                  :rules="emailRules"
                  v-model="email"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-btn
                  size="large"
                  class="w-100"
                  variant="outlined"
                  @click="sendreset"
                  :disabled="shouldDisable"
                >
                  <span class="ml-4">Jelszó reset email küldése</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-actions>
        </v-window-item>
      </v-window>
    </v-card>
  </v-row>

  <SaveDialog :showdialog="isSaveDialogVisible" text="Email sikeresen elküldve." okayText="OK" />
</template>

<script>
import { defineComponent } from 'vue'
import { sendPWReset } from '../services/userServices'
import SaveDialog from '../components/SaveDialog.vue'
import { RszValidators } from '../modules/rszValidators'


export default defineComponent({
  name: 'ForgotPassword',
  components: {
    SaveDialog,
  },
  data() {
    return {
      email: null,
      tab: null,
      isSaveDialogVisible: false,
      shouldDisable: true,
      emailRules: [
        (value) => {
          if (!value) return false
          if (RszValidators.emailPattern.test(value)) {
            this.shouldDisable = false
            return true
          }
          this.shouldDisable = true
          return `Kérjük, érvényes email címet adjon meg!`
        },
      ],
    }
  },
  methods: {
    async sendreset() {
      await sendPWReset(this.email)
      this.isSaveDialogVisible = true
    },
  },
})
</script>

<style scoped>
p {
  margin-top: 1rem;
  text-align: justify;
}
</style>
